import { useEffect, useRef, useState } from "react";
import { useFetch, usePOST } from "../../../../ApiS";
import { Col, Row } from "../../../../ApiS/Grid-system/Grid-system";
import Title from "../../../Title/Title";
import Input from "../../../Inputs/Input";
import MainButton from "../../../Buttons/MainButton";
import { BiEdit } from "react-icons/bi";
import Loader from "../../../Loader";
import { AxiosError } from "axios";
import { toast, ToastContainer } from "react-toastify";
import JoditEditor from "jodit-react";
import parse from "html-react-parser";
import Data from "../../../Data/Data";

type Error = {
  about_program_en?: string[];
  about_program_ar?: string[];
};

export default function About() {
  const [popup, setpopup] = useState(false);
  const [errors, setErrors] = useState<Error>({});

  const { data, isLoading } = useFetch("admin/infos", "admin/infos");

  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const { handleSubmit, handleChangeInput, mutation , setFormData , formData } = usePOST(
    {},
    () => {
      window.location.reload();
    },
    (error) => {
      onError(error);
    }
  );

  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: "هناك خطأ في عملية التعديل",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);

  return (
    <>
      <ToastContainer position="bottom-left" />
      <Row>
        <Col lg={4}>
          <Title title="حول البرنامج" />
        </Col>
      </Row>

      {/* <Row justify="center">
        <Col lg={11} md={10} sm={10} className="!px-4 !py-4 text-lg">
          <div className="mt-1">
            يهدف برنامج الإجازة في علوم الإدارة إلى تحقيق النتائج التالية:
          </div>
          <div className="mt-1 mx-8">
            <ol className="list-decimal">
              <li className="mt-1">
                إعداد الطلاب وتأهيلهم في مجال إدارة  الموارد البشرية والتسويق
                والمالية والمصارف وتزويدهم بمستوى عال من المعرفة بما يواكب
                التقدم العلمي والتقني الحاصل على المستوى الدولي.
              </li>
              <li className="mt-1">
                تكوين شخصية الطالب العلمية والتقنية وتنميتها بالاستفادة من كافة
                المزايا التي يقدمها التعلم الافتراضـــي والمساهمة في تدعيم
                وتقوية التكوين العلمي للطلاب في مجال إدارة  الموارد البشرية
                والتسويق والمالية والمصارف.
              </li>
              <li className="mt-1">
                المساهمة في النهضة العلمية العربية وزيــادة الأبحاث العلمية
                والدراسات المختلفة (كماً ونوعاً) التـــي تساهم في تحقيق التنمية
                الاقتصادية والتي تساهم في إيجاد حلول لمختلف القضايا الإشكالية
                التي تواجه التطور الاقتصادي في الوطن العربي.
              </li>
            </ol>
          </div>
          <div className="mt-1">محصلات التعلم</div>
          <div className="mt-1">
            من أهم الصفات التي يجب أن يتمتع بها خريج علوم الإدارة مقدرته على:
          </div>
          <div className="mt-1 mx-8">
            <ol className="list-decimal">
              <li className="mt-1">اكتساب المعرفة والفهم:</li>
            </ol>
          </div>
          <div className="mt-1">
            عند الحصول على الشهادة سيكون الطالب قادراً على إظهار معرفة وفهم في:
          </div>
          <div className="mt-1">أولاً- اختصاص إدارة الموارد البشرية:</div>
          <div className="mt-1 mx-8">
            <ol className="list-disc">
              <li className="mt-1">
                التعرف على مبادئ و ووظائف ومداخل إدارة الموارد البشرية.
              </li>
              <li className="mt-1">
                التعرف على طبيعة المشاكل التي تعاني منها الموارد البشرية
                والحاجات التطويرية للموارد البشرية وفهم ماهية العوامل المؤثرة
                فيها.
              </li>
              <li className="mt-1">
                التعرف على أهمية إدارة الموارد البشرية للمنظمات الحديثة.
              </li>
              <li className="mt-1">
                التعرف على العلاقة بين إدارة الموارد البشرية كجزء من علوم
                الإدارة والإدارات الأخرى في المنظمة.
              </li>
              <li className="mt-1">
                التعرف على المفاهيم والعمليات المرتبطة بكيفية استثمار العنصر
                البشري.
              </li>
              <li className="mt-1">
                التعرف على الجوانب السلوكية المؤثرة في فاعلية إدارة الموارد
                البشرية.
              </li>
              <li className="mt-1">الموارد البشرية.</li>
            </ol>
          </div>
        </Col>
      </Row> */}
      {isLoading && <Loader />}
      <Row>
        <Col>
          <Data text={data?.program?.about_program_ar}/>
        </Col>
      </Row>

      <div
        className={`flex z-10 justify-center  items-center fixed  bottom-10 left-5 font-bold text-5xl bg-Secondary text-white cursor-pointer w-14 h-14 rounded-full`}
        onClick={() => setpopup(true)}
      >
        <span className="mb-3">
          <BiEdit className="mt-2" size={35} />
        </span>
      </div>

      {popup === true && (
        <Row>
          <Col
            lg={12}
            className="h-[100vh]  w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"around"}
              className="relative w-[47%] max-lg:w-[80%] max-md:w-full h-[80%] overflow-y-scroll bg-white p-5 border-2 rounded-xl "
            >
              <div
                className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(false)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Col lg={12} className="flex justify-center !mt-2">
                <Title title="قم بادخال معلومات البرنامج" />
              </Col>

              <>
                <Col lg={10} sm={10}>
                  <h1 className="mb-4 text-2xl text-black font-bold">
                    وصف الوصف باللغة العربية
                  </h1>

                  <JoditEditor
                    value={data?.program?.about_program_ar}
                    onChange={(e) =>
                      setFormData({ ...formData, "program-about_program_en": e })
                    }
                  />
                </Col>
                <Col lg={10} sm={10}>
                  <h1 className="mb-4 text-2xl text-black font-bold">
                    وصف الوصف باللغة الانكليزية
                  </h1>

                  <JoditEditor
                    value={data?.program?.about_program_en}
                    onChange={(e) =>
                      setFormData({ ...formData, "program-about_program_ar": e })
                    }
                  />
                </Col>
              </>

              <Row justify="around">
                <Col lg={5} sm={6} className="!mt-3 ">
                  <MainButton
                    titlebtn={"تعديل"}
                    className="!w-full "
                    onClick={() => handleSubmit("admin/infos/update")}
                  />
                </Col>
                <Col
                  lg={5}
                  sm={6}
                  className="!mt-3 "
                  onClick={() => setpopup(false)}
                >
                  <MainButton
                    titlebtn="الغاء"
                    className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                  />
                </Col>
              </Row>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
}
